import { useQuery } from "@apollo/client";

import { type MyLensesSubmissionError } from "../../gql-generated/types";
import { type ApolloResult } from "../../shared/models";
import {
    type GetSubmissionErrorsInfoQuery,
    type GetSubmissionErrorsInfoQueryVariables,
    getSubmissionErrorsInfo,
} from "../api/queries";

export interface SubmissionErrorsResult {
    submissionErrors: MyLensesSubmissionError[];
    hasRejectionErrors: boolean; // will be true when lens is invalid or rejected
    hasSubmissionErrors: boolean; // will be true when lens has any errors, including partial errors
}

export const useSubmissionErrors = (lensId = ""): ApolloResult<SubmissionErrorsResult> => {
    const { loading, data, error } = useQuery<GetSubmissionErrorsInfoQuery, GetSubmissionErrorsInfoQueryVariables>(
        getSubmissionErrorsInfo,
        {
            variables: {
                lensId,
            },
            skip: !lensId,
        },
    );

    const submissionErrors = [...(data?.getMyLensesSubmissionErrors.submissionErrorsList ?? [])].filter(
        (submissionError) => !!submissionError.heading, // filter out empty errors
    );

    // will be true when lens is invalid or rejected
    const hasRejectionErrors = data?.getLens.lens?.rejectionErrors?.hasSubmissionErrors ?? false;

    return { loading, submissionErrors, hasRejectionErrors, hasSubmissionErrors: submissionErrors.length > 0, error };
};
